import { authClient } from '@/shared/api';
import { type ApiResult } from '@/shared/utils';
import { Login, RefreshSession, UserInfo } from '../model/types';
import { authApiMock as mockApi } from './auth.api.mock';

const login = (payload: Login): Promise<ApiResult<RefreshSession>> =>
    authClient.post<RefreshSession>('/auth/login', payload);

const loginSso = () => {
    window.location.href = `${authClient.baseUrl}/auth/login-sso`;
};

const logout = async (): Promise<ApiResult<boolean>> =>
    authClient.post<boolean>('/auth/logout', {});

const refresh = async (signal?: AbortSignal): Promise<ApiResult<RefreshSession>> =>
    authClient.post<RefreshSession>('/auth/refresh', {}, { signal });

const getUserInfo = async (signal?: AbortSignal): Promise<ApiResult<UserInfo>> =>
    authClient.get<UserInfo>('/auth/introspect', { signal });

export const realApi = { login, loginSso, logout, refresh, getUserInfo };

export const authApi = import.meta.env.VITE_MOCK_AUTH === 'true' ? mockApi : realApi;
